export const BASE_URL =
  process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'demo'
    ? '/api'
    : RWMS_BASE_URL;

export const BASE_WS_URL = RWMS_BASE_WS_URL;

export const STATIC_URL = RWMS_STATIC_URL;
